import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppNS } from 'app';
import { apiCreateInspectorProfile, apiUpdateInspectorProfile } from 'app/api/agency-staff/agency-staff';

import { AppThunk } from './index';

export interface AgencyInspectorsProfilesState {
  profile: AppNS.InspectorProfile | null;
  isUpdating: boolean;
  isUpdateSuccess: boolean;
  updatingErrors: any;
}

const initialState: AgencyInspectorsProfilesState = {
  profile: null,
  isUpdating: false,
  isUpdateSuccess: false,
  updatingErrors: null,
};

const AgencyInspectorsProfilesStateSlice = createSlice({
  name: 'agencyInspectorsProfiles',
  initialState,
  reducers: {
    createProfileStart(state: AgencyInspectorsProfilesState) {
      state.isUpdating = true;
      state.isUpdateSuccess = false;
      state.updatingErrors = null;
    },
    createProfileSuccess(
      state: AgencyInspectorsProfilesState,
      action: PayloadAction<AppNS.Params>
    ) {
      state.profile = {id: action.payload.id, ...action.payload.properties};
      state.isUpdating = false;
      state.isUpdateSuccess = true;
    },
    createProfileFailed(state: AgencyInspectorsProfilesState, action: PayloadAction<any>) {
      state.isUpdating = false;
      state.updatingErrors = action.payload;
      state.isUpdateSuccess = false;
    },
    updateProfileStart(state: AgencyInspectorsProfilesState) {
      state.isUpdating = true;
      state.updatingErrors = null;
      state.isUpdateSuccess = false;
    },
    updateProfileSuccess(
      state: AgencyInspectorsProfilesState,
      action: PayloadAction<AppNS.Params>
    ) {
      state.profile = {...state.profile, ...action.payload.properties};
      state.isUpdating = false;
      state.isUpdateSuccess = true;
    },
    updateProfileFailed(state: AgencyInspectorsProfilesState, action: PayloadAction<any>) {
      state.isUpdating = false;
      state.updatingErrors = action.payload;
      state.isUpdateSuccess = false;
    },
    reset(state: AgencyInspectorsProfilesState) {
      state.isUpdating = false;
      state.updatingErrors = null;
      state.isUpdateSuccess = false;
    },
  },
});

export const {
  createProfileStart,
  createProfileSuccess,
  createProfileFailed,
  updateProfileStart,
  updateProfileSuccess,
  updateProfileFailed,
  reset,
} = AgencyInspectorsProfilesStateSlice.actions;

export default AgencyInspectorsProfilesStateSlice.reducer;

export const createInspectorProfile = (params: Omit<AppNS.InspectorProfile, 'id'>): AppThunk => async (dispatch) => {
  try {
    dispatch(createProfileStart());
    const result = await apiCreateInspectorProfile(params);
    dispatch(createProfileSuccess(result));
  } catch (err) {
    dispatch(createProfileFailed(err));
  }
};

export const updateInspectorProfile = (params: AppNS.InspectorProfile): AppThunk => async (dispatch) => {
  try {
    dispatch(updateProfileStart());
    const result = await apiUpdateInspectorProfile(params);
    dispatch(updateProfileSuccess(result));
  } catch (err) {
    dispatch(updateProfileFailed(err));
  }
};
